<template>
  <div class="home-image" @click="toDialogue">
    <img src="@/assets/images/home_head.png" alt="首页图">
  </div>
</template>
<script>
export default {
  methods: {
    toDialogue() {
      this.$router.push('/layout/dialogue')
    }
  }
}
</script>

<style scoped lang="scss">
.home-image {
  text-align: center;
  img {
    height: 287px;
  }
}
</style>